import { render } from "./orderTrackDetailsModel.vue?vue&type=template&id=0de56437"
import script from "./orderTrackDetailsModel.vue?vue&type=script&lang=js"
export * from "./orderTrackDetailsModel.vue?vue&type=script&lang=js"

import "./orderTrackDetailsModel.vue?vue&type=style&index=0&id=0de56437&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__